<template>
  <div class="ehc-connect-acc">
    <div class="container-fluid py-4 bg-white">
      <div class="mb-3 text-center">
        <span
          class="robo-24-500 txt-pri">{{ ehcDoctorData ? "Thông tin tài khoản Hola HIS" : "Kết nối tài khoản Hola HIS với hệ thống website" }}</span>
      </div>
      <div v-if="!ehcDoctorData" class="ehc-info-panel p-4 bound-border">
        <form @submit.prevent="loginEHC" autocomplete="off" class="ehc-login-form max-w-md mx-auto">
          <div class="form-group mb-3">
            <label for="ehc-username" class="robo-16-400 mb-1">Tên đăng nhập</label>
            <input type="text" id="ehc-username" v-model="ehcUsername" class="form-control bg-white robo-16-400" required
                   placeholder="Nhập tên đăng nhập" />
          </div>
          <div class="form-group mb-3">
            <label for="ehc-password" class="robo-16-400 mb-1">Mật khẩu</label>
            <input type="password" id="ehc-password" v-model="ehcPassword" class="form-control bg-white robo-16-400" required
                   placeholder="Nhập mật khẩu" />
          </div>
          <button type="submit" class="btn btn-primary robo-16-500 px-4 py-2 w-full uppercase">Kết nối tài khoản</button>
          <div v-if="ehcLoginError" class="text-danger mt-3 robo-16-400">{{ ehcLoginError }}</div>
        </form>
      </div>
      <div v-else class="ehc-info-panel mt-4 p-4 bound-border">
        <div v-if="ehcSystemError" class="text-danger mb-2 robo-16-400">{{ ehcSystemError }}</div>
        <div v-if="ehcWSError" class="text-danger mb-2 robo-16-400">{{ ehcWSError }}</div>
        <div v-if="ehcPatientError" class="text-danger mb-2 robo-16-400">{{ ehcPatientError }}</div>
        <div v-if="ehcServicesError" class="text-danger mb-2 robo-16-400">{{ ehcServicesError }}</div>
        <div v-if="ehcPMRError" class="text-danger mb-2 robo-16-400">{{ ehcPMRError }}</div>
        <div class="row">
          <div class="col-12 mb-4">
            <label class="robo-16-400 mb-1">Tên hệ thống</label>
            <div class="ehc-box p-3 bound-border bg-white robo-16-500 rounded-md">{{ ehcSystemName }}</div>
          </div>
          <div class="col-md-6 mb-4">
            <label class="robo-16-400 mb-1">Tên đăng nhập</label>
            <div class="ehc-box p-3 bound-border bg-white robo-16-500 rounded-md">{{ ehcUsernameDisplay }}</div>
          </div>
          <div class="col-md-6 mb-4">
            <label class="robo-16-400 mb-1">Tên bác sĩ</label>
            <div class="ehc-box p-3 bound-border bg-white robo-16-500 rounded-md">{{ ehcDoctorName }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4">
            <label class="robo-16-400 mb-1">Danh sách phòng khám</label>
            <div class="ehc-box p-3 bound-border bg-white robo-16-400 rounded-md">{{ ehcClinicsList }}</div>
          </div>
          <div class="col-12 mb-4">
            <label class="robo-16-400 mb-1">Danh sách phòng ban</label>
            <div class="ehc-box p-3 bound-border bg-white robo-16-400 rounded-md">{{ ehcDepartmentsList }}</div>
          </div>
          <div class="col-12">
            <label class="robo-16-400 mb-1">Ghi chú</label>
            <div class="ehc-box p-3 bound-border bg-white robo-16-400 rounded-md">Đây là thông tin tài khoản Hola HIS
              của
              bạn. Nếu có vấn đề, vui lòng liên hệ quản trị viên.
            </div>
          </div>
        </div>
      </div>
    </div>
    <EHCProgressConnect :isProgressSetting="isProgressSetting" @hideModal="closeProgressModal" @ehcConnectComplete="EHCConnectComplete" />
  </div>
</template>
<script>
import EHCSyncRequest from '@/api/request/EHCSyncRequest'
import EHCProgressConnect from '@components/EHCConnectAcc/EHCProgressConnect.vue'

const api = new EHCSyncRequest()

export default {
  name: 'EHCConnectAcc',
  components: { EHCProgressConnect },
  props: {
    ehcData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      ehcUsername: '',
      ehcPassword: '',
      ehcLoginError: '',
      ehcSystemError: '',
      ehcWSError: '',
      ehcPatientError: '',
      ehcServicesError: '',
      ehcPMRError: '',
      ehcDoctorData: null,
      showChangePasswordModal: false,
      changePassForm: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      changePassLoading: false,
      changePassError: '',
      isProgressSetting: false
    }
  },
  computed: {
    ehcUsernameDisplay () {
      if (!this.ehcDoctorData) return ''
      return (
        this.ehcDoctorData.username ||
        ''
      )
    },
    ehcDoctorName () {
      if (!this.ehcDoctorData) return ''
      return (
        this.ehcDoctorData.doctor_name ||
        ''
      )
    },
    ehcSystemName () {
      if (!this.ehcDoctorData) return ''
      return (
        this.ehcDoctorData.system_name ||
        ''
      )
    },
    ehcClinicsList () {
      if (!this.ehcDoctorData) return ''
      const clinics = this.ehcDoctorData.clinics
      if (!clinics) return ''
      return clinics
    },
    ehcDepartmentsList () {
      if (!this.ehcDoctorData) return ''
      const deps = this.ehcDoctorData.departments
      if (!deps) return ''
      return deps
    }
  },
  watch: {
    ehcData: {
      handler (newVal) {
        this.preloadEHCData(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    preloadEHCData (data) {
      if (data) {
        this.ehcDoctorData = data
        if (this.ehcDoctorData && this.ehcDoctorData.username) {
          this.ehcUsername = this.ehcDoctorData.username
        }
        try {
          window.localStorage.setItem('ehcDoctorData', JSON.stringify(this.ehcDoctorData))
        } catch (err) {
          console.error('Error saving to localStorage:', err)
        }
      } else {
        this.ehcDoctorData = null
        this.ehcUsername = ''
        try {
          window.localStorage.removeItem('ehcDoctorData')
        } catch (err) {
          console.error('Error removing from localStorage:', err)
        }
      }
    },
    async loginEHC () {
      this.ehcLoginError = ''
      this.ehcDoctorData = null
      this.ehcSystemError = ''
      this.ehcWSError = ''
      this.ehcPatientError = ''
      this.ehcServicesError = ''
      this.ehcPMRError = ''
      try {
        let doctorRes = await api.ehcDoctorLogin({
          username: this.ehcUsername,
          password: this.ehcPassword
        })
        if (!doctorRes || doctorRes?.error) {
          this.$toast.open({ message: 'Đăng nhập bác sĩ thất bại.', type: 'error', position: 'top-right', duration: 5000 })
          return
        }
        this.$emit('refresh')
        this.$toast.open({ message: 'Đăng nhập bác sĩ thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isProgressSetting = true
      } catch (err) {
        this.$toast.open({ message: 'Lỗi mạng hoặc máy chủ khi đăng nhập bác sĩ.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('Doctor login exception:', err)
      }
    },
    EHCConnectComplete () {
      this.$emit('refresh')
      this.$toast.open({ message: 'Kết nối và đồng bộ dữ liệu Hola HIS hoàn tất!', type: 'success', position: 'top-right', duration: 5000 })
    },
    closeProgressModal () {
      this.isProgressSetting = false
      setTimeout(() => {
        window.location.reload()
      }, 750)
    }
  }
}
</script>
<style scoped>
.ehc-info-panel {
  border-radius: 0.75em;
  border: 1px solid #e3e6ed;
  background: #f8f9fb;
}
</style>
